// Copy of https://github.com/box/box-ui-elements/blob/830bf71bef5720a5e6ba128afa35152112674c17/src/styles/variables.ts

/* File auto-generated */
var white = '#fff'; // white

var black = '#000'; // black

var bdlBoxBlue = '#0061d5'; // bdl-box-blue

var bdlBoxBlue80 = '#3381dd'; // bdl-box-blue-80

var bdlGray = '#222'; // bdl-gray

var bdlGray80 = '#4e4e4e'; // bdl-gray-80

var bdlGray65 = '#6f6f6f'; // bdl-gray-65

var bdlGray50 = '#909090'; // bdl-gray-50

var bdlGray40 = '#a7a7a7'; // bdl-gray-40

var bdlGray30 = '#bcbcbc'; // bdl-gray-30

var bdlGray10 = '#e8e8e8'; // bdl-gray-10

var bdlGray05 = '#f4f4f4'; // bdl-gray-05

var bdlGridUnitPx = '4'; // bdl-grid-unit-px
// xlarge-screen

export { bdlBoxBlue, bdlBoxBlue80, bdlGray, bdlGray05, bdlGray10, bdlGray30, bdlGray40, bdlGray50, bdlGray65, bdlGray80, bdlGridUnitPx, black, white };